import { createSelector } from '@reduxjs/toolkit';
import { FOfferType } from '../../../../packages/JsonQuery';
import { selectOfferType } from 'shared/selectors/jsonQuery';
import { selectRegionId } from 'shared/selectors/location';
import { selectPromoSearchTypes } from 'shared/selectors/promoSearchTypes';
import {
  SUBSIDIZED_MORTGAGE_ENABLED_KEY,
  SUBSIDIZED_MORTGAGE_LABEL_TEXT_IN_MIXED_LISTING_KEY,
  SUBSIDIZED_MORTGAGE_EXCLUDED_REGIONS_KEY,
  SUBSIDIZED_MORTGAGE_OPTION_VALUE,
} from 'shared/constants/subsidizedMortgage';
import { IConfig } from '@cian/config/shared';

export const selectMortgagePromoSearchTypeOptions = (config: IConfig) =>
  createSelector([selectRegionId, selectOfferType, selectPromoSearchTypes], (regionId, offerType, promoSearchTypes) => {
    const subsidizedMortgageEnabled = config.get<boolean>(SUBSIDIZED_MORTGAGE_ENABLED_KEY);
    const subsidizedMortgageLabelText = config.get<string>(SUBSIDIZED_MORTGAGE_LABEL_TEXT_IN_MIXED_LISTING_KEY) ?? '';
    const subsidizedMortgageExcludedRegions = config.get<number[]>(SUBSIDIZED_MORTGAGE_EXCLUDED_REGIONS_KEY) ?? [];

    const isSubsidizedMortgageOptionAvailable =
      subsidizedMortgageEnabled &&
      offerType !== FOfferType.FlatNew &&
      subsidizedMortgageLabelText &&
      !subsidizedMortgageExcludedRegions.includes(regionId);

    return [
      { label: 'Неважно', value: null },
      ...(isSubsidizedMortgageOptionAvailable
        ? [
            {
              label: subsidizedMortgageLabelText,
              value: SUBSIDIZED_MORTGAGE_OPTION_VALUE,
            },
          ]
        : []),
      ...(promoSearchTypes?.mortgage.map(({ value, name: label }) => ({
        value,
        label,
      })) || []),
    ];
  });
